import { locationIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

export const createConsolidationFulfillmentGroup = {
  name: "createConsolidationFulfillmentGroup" as const,
  input: z.object({
    teamId: z.string(),
    originLocationId: locationIdFormat.schema,
  }),
  output: z.object({ fulfillmentGroupId: z.string() }),
};
